// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-chart[data-v-cf124054] {\n  height: 330px;\n  padding: 18px 16px 12px;\n}\n.chart-frame[data-v-cf124054] {\n  position: relative;\n  height: 100%;\n}\n.project-chart[data-v-cf124054]  canvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n@media (max-width: 599px) {\n.project-chart[data-v-cf124054] {\n    height: 310px;\n    padding: 14px 10px 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
